import type { ReactNode } from 'react';

import { Collect } from '@sorare/core/src/atoms/icons/Collect';
import { HalfCircularProgressBar } from '@sorare/core/src/atoms/loader/CircularProgressIndicator/HalfCircularProgressBar/index.tsx';
import { WidgetButton } from '@sorare/core/src/atoms/ui/WidgetButton/index.tsx';
import type { Unit } from '@sorare/core/src/lib/style.ts';

import { IconWrapper } from '#src/components/series/SeriesMissions/ui.tsx';

type Props = {
  chip: ReactNode;
  to: string;
  size?: Unit;
  progresses: number[];
};

export const DumbFeaturedCollectionTaskWidget = ({
  chip,
  to,
  size = 6,
  progresses,
}: Props) => (
  <WidgetButton to={to} chip={chip}>
    <HalfCircularProgressBar
      size={size}
      progresses={progresses}
      colors={[
        {
          from: 'var(--c-inventory-yellow)',
          to: 'var(--c-inventory-yellow)',
        },
      ]}
    />
    <IconWrapper>
      <Collect
        size={(size - 2) as Unit}
        colors={['var(--c-inventory-yellow)', 'var(--c-inventory-orange)']}
      />
    </IconWrapper>
  </WidgetButton>
);
